<div id="home-wrapper">
  <app-breadcrumb
    [filter]="getSelectedListName()"
    [path]="'COMPONENT.SIDEBAR.start' | translate"
    [station]="'COMPONENT.SIDEBAR.my_lists' | translate"
    [title]="'COMPONENT.PAGE_PATIENT_LIST.patient_list' | translate"
  >
    <div class="flex justify-between items-center w-full">
      <div class="block justify-start w-full"></div>
      <!-- Presentation Mode -->
      <div
        class="presentation-wrapper"
        [class.active]="toggleState"
        (click)="handleToggle(!toggleState)"
      >
        <span class="presentation-label"> {{ 'PRESENTATION.mode' | translate }}</span>
        <mat-icon [ngClass]="toggleState ? 'text-[var(--primary-color)]' : 'text-gray-500'">
          {{ toggleState ? 'visibility' : 'visibility_off' }}
        </mat-icon>
      </div>
    </div>
  </app-breadcrumb>
  <div
    [ngClass]="{
      'absolute top-0 right-0': currentBreakpoint() === 'handsetLandscape',
    }"
    class="select-box flex flex-col"
  >
    <div class="flex flex-row justify-between w-full">
      <!-- Patient List Tabs -->
      <div class="block justify-start w-full">
        <div class="flex items-center">
          <mat-select
            *ngIf="caseLists.length > 0"
            [value]="getSelectedListId()"
            (selectionChange)="onListSelectionChange($event)"
            [hideSingleSelectionIndicator]="true"
            name="patientList"
            class="w-48 bg-white !font-light filter-item standalone-select"
          >
            <mat-select-trigger>
              {{ getSelectedListName() }}
            </mat-select-trigger>

            @for (list of caseLists; track list.listIdentifier.name) {
              <mat-option [value]="list.listIdentifier.name">
                {{ list.listIdentifier?.name }}
              </mat-option>
            }
          </mat-select>
        </div>
      </div>
      <!-- sort and search area -->
      <div *ngIf="currentToggleButton === 'patientList'" class="patient-list-sort-search gap-2">
        <mat-select
          [value]="sortSelection().value"
          (selectionChange)="selectionChange($event)"
          [hideSingleSelectionIndicator]="true"
          panelClass="sort-selection"
          class="w-48 bg-white !font-light filter-item standalone-select"
        >
          <mat-select-trigger>
            {{ displayText | translate }}
          </mat-select-trigger>

          @for (option of sortOptions; track option.value) {
            <mat-option
              class="!flex !items-center !justify-between !flex-row-reverse !gap-2 !font-light"
              [value]="option.value"
              (onSelectionChange)="onSelectionChange($event)"
            >
              <span>{{ option.translateKey | translate }}</span>

              @if (sortSelection().value === option.value) {
                <app-sort-indicator [sortDirection]="sortSelection().sortOrder" />
              }
            </mat-option>
          }
        </mat-select>

        <div class="flex flex-row justify-between items-center bg-white search-container">
          <input
            (input)="onSearchFieldInput()"
            [(ngModel)]="searchQuery"
            [placeholder]="'COMPONENT.PAGE_PATIENT_LIST.placeholder_search_in_list' | translate"
            class="font-light search-input"
            matInput
            type="search"
          />
          <mat-icon>search</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!-- Patients lists -->
  <div
    *ngIf="currentToggleButton === 'patientList'"
    [ngClass]="{ 'w-11/12': currentBreakpoint() === 'handsetLandscape' }"
    class="table-container"
  >
    <!-- table for browser und quer handy  -->
    <table
      (matSortChange)="sortData($event)"
      *ngIf="currentBreakpoint() !== 'handsetPortrait'"
      [dataSource]="patientListToShow"
      class="home-patient-list"
      mat-table
      matSort
    >
      <!-- Patient column -->
      <ng-container matColumnDef="patient">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          {{ 'COMPONENT.PAGE_PATIENT_LIST.patients' | translate }}
        </th>
        <td
          *matCellDef="let patient"
          mat-cell
          [routerLink]="['/patient-details', patient.patient_details.case.related_case_id]"
          style="cursor: pointer"
        >
          <div class="flex items-center">
            <mat-icon
              (click)="toggleBookmark(patient, $event)"
              [ngClass]="{
                'text-amber-400': isPatientBookmarked(patient),
                'text-gray-300': !isPatientBookmarked(patient),
              }"
              class="cursor-pointer transition-colors duration-300"
            >
              {{ isPatientBookmarked(patient) ? 'bookmark' : 'bookmark_border' }}
            </mat-icon>

            <app-home-patient-basic-info
              [patient]="patient"
              class="patient-list-basic flex-grow"
            ></app-home-patient-basic-info>

            <mat-icon
              *ngIf="toggleState"
              [ngClass]="{
                'opacity-30': !isPatientViewed(patient),
                'opacity-100': isPatientViewed(patient),
              }"
              class="text-[var(--primary-color)] mr-4 transition-opacity duration-300"
            >
              visibility
            </mat-icon>
          </div>
        </td>
      </ng-container>

      <!-- Course column -->
      <ng-container matColumnDef="followUp">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          {{ 'COMPONENT.PAGE_PATIENT_LIST.followUp' | translate }}
        </th>

        <td *matCellDef="let patient" mat-cell>
          <app-home-patient-visit
            class="patient-list-visit"
            [currentBreakpoint]="currentBreakpoint()"
            [patient]="patient"
            [viewContentI18n]="viewContentI18nVisiteRecord"
          ></app-home-patient-visit>
        </td>
      </ng-container>

      <!-- Tasks column -->
      <ng-container matColumnDef="tasks">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          {{ 'COMPONENT.PAGE_PATIENT_LIST.tasks' | translate }}
        </th>

        <td *matCellDef="let patient" mat-cell>
          <app-home-patient-tasks
            [currentBreakpoint]="currentBreakpoint()"
            [patient]="patient"
            [viewContentI18n]="viewContentI18nTask"
            class="patient-list-tasks"
          ></app-home-patient-tasks>
        </td>
      </ng-container>

      <!-- Header Row -->
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>

      <!-- Data Rows -->
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>

    <!-- table for the mobile version, vertical handy -->
    <table
      *ngIf="currentBreakpoint() === 'handsetPortrait'"
      [dataSource]="patientListToShow"
      class="mat-elevation-z8 table-handy"
      mat-table
      multiTemplateDataRows
    >
      <ng-container matColumnDef="patients">
        <th *matHeaderCellDef mat-header-cell>
          {{ 'COMPONENT.PAGE_PATIENT_LIST.patients' | translate }}
        </th>
        <td
          *matCellDef="let patient"
          mat-cell
          [routerLink]="['/patient-details', patient.patient_details.case.related_case_id]"
          style="cursor: pointer"
        >
          <div class="flex items-center justify-between">
            <app-home-patient-basic-info
              [patient]="patient"
              class="patient-list-basic"
            ></app-home-patient-basic-info>
            <div class="flex items-center">
              <mat-icon
                (click)="toggleBookmark(patient, $event)"
                [ngClass]="{
                  'text-amber-400': isPatientBookmarked(patient),
                  'text-gray-300': !isPatientBookmarked(patient),
                }"
                class="cursor-pointer transition-colors duration-300"
              >
                {{ isPatientBookmarked(patient) ? 'star' : 'star_border' }}
              </mat-icon>

              <app-home-patient-basic-info
                [patient]="patient"
                class="patient-list-basic flex-grow"
              ></app-home-patient-basic-info>

              <mat-icon
                *ngIf="toggleState"
                [ngClass]="{
                  'opacity-30': !isPatientViewed(patient),
                  'opacity-100': isPatientViewed(patient),
                }"
                class="text-[var(--primary-color)] mr-4 transition-opacity duration-300"
              >
                visibility
              </mat-icon>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="expand">
        <th *matHeaderCellDef aria-label="row actions" mat-header-cell>&nbsp;</th>
        <td *matCellDef="let element" mat-cell>
          <button
            (click)="
              expandedElement = expandedElement === element ? null : element;
              $event.stopPropagation()
            "
            aria-label="expand row"
            mat-icon-button
          >
            <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Expanded Content Column -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length" mat-cell>
          <div
            [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
            class="example-element-detail"
          >
            <div class="example-element-diagram">
              <span>
                {{ 'COMPONENT.PAGE_PATIENT_LIST.followUp' | translate }}
              </span>
              <app-home-patient-visit
                [currentBreakpoint]="currentBreakpoint()"
                [patient]="element"
                [viewContentI18n]="viewContentI18nVisiteRecord"
                class="patient-list-visit"
              ></app-home-patient-visit>
              <span>{{ 'COMPONENT.PAGE_PATIENT_LIST.tasks' | translate }}</span>
              <app-home-patient-tasks
                [currentBreakpoint]="currentBreakpoint()"
                [patient]="element"
                [viewContentI18n]="viewContentI18nTask"
                class="patient-list-tasks"
              ></app-home-patient-tasks>
            </div>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="columnsToDisplayWithExpand" mat-header-row></tr>
      <tr
        (click)="expandedElement = expandedElement === element ? null : element"
        *matRowDef="let element; columns: columnsToDisplayWithExpand"
        [class.example-expanded-row]="expandedElement === element"
        class="example-element-row"
        mat-row
      ></tr>
      <tr *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" mat-row></tr>
    </table>
  </div>
</div>
